export enum ConversationTypeEnum {
    GroupConversation = 0,
    SingleConversation = 1
}

export enum AvaInitialsType {
    Group = 0,
    Single = 1
}
